export default "__VITE_ASSET__1de047f6__"